import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

interface SearchBarProps {
  defaultValue?: string;
  size?: "sm" | "lg";
  placeholder?: string;
  className?: string;
  onSearch?: (keyword: string) => void;
}

export default function SearchBar({
  defaultValue = "",
  size = "sm",
  placeholder = "搜索电影、电视剧或字幕关键词",
  className = "",
  onSearch,
}: SearchBarProps) {
  const [value, setValue] = useState(defaultValue);
  const navigate = useNavigate();

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const keyword = value.trim();
    if (!keyword) return;
    if (onSearch) {
      onSearch(keyword);
    } else {
      navigate(`/search?q=${encodeURIComponent(keyword)}`);
    }
  };

  const isLarge = size === "lg";

  return (
    <form
      onSubmit={handleSubmit}
      role="search"
      className={`flex w-full items-center gap-2 rounded-full border border-background-300 bg-background-50 transition-colors focus-within:border-primary-400 ${
        isLarge ? "h-12 pl-5 pr-1.5" : "h-10 pl-4 pr-1"
      } ${className}`}
    >
      <i className={`ri-search-line text-foreground-400 ${isLarge ? "text-lg" : "text-base"}`}></i>
      <input
        type="search"
        name="q"
        value={value}
        onChange={(event) => setValue(event.target.value)}
        placeholder={placeholder}
        aria-label="站内搜索"
        className={`min-w-0 flex-1 bg-transparent text-foreground-900 placeholder:text-foreground-400 focus:outline-none ${
          isLarge ? "text-base" : "text-sm"
        }`}
      />
      <button
        type="submit"
        className={`flex shrink-0 items-center justify-center gap-1 whitespace-nowrap rounded-full bg-primary-500 font-medium text-background-50 transition-colors hover:bg-primary-600 ${
          isLarge ? "h-9 px-5 text-sm" : "h-8 px-4 text-sm"
        }`}
      >
        <i className="ri-search-line"></i>
        搜索
      </button>
    </form>
  );
}